<div class="text-center">
    <h6 class="m-8 p-4">{{ title }}</h6>
    <div mat-dialog-content [style.width]="'50'">
        <mat-spinner [style.margin]="'auto'" [style.overflow-x]="'hidden'"></mat-spinner>
    </div>
</div>